import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const SidebarGroup = ({ children, id }) => {
  const headingId = `sidebar-group-${id}`;

  return (
    <section
      aria-labelledby={headingId}
      className="sidebar-nav__group"
      data-sidebar-group={id}
      role="group"
    >
      <h2 className="sidebar-nav__group-heading" id={headingId}>
        <FormattedMessage id={`navigation.group.${id}`} />
      </h2>
      {children}
    </section>
  );
};

SidebarGroup.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired
};

export { SidebarGroup };
